import { createContext, useMemo, useState } from "react";
import { IgnitionRegime } from "../types/ignitionRegime";

interface IgnitionRegimeContextType {
  selectedRegime: IgnitionRegime | null;
  setSelectedRegime: (regime: IgnitionRegime | null) => void;
}

const IgnitionRegimeContext = createContext<IgnitionRegimeContextType>({
  selectedRegime: null,
  setSelectedRegime: () => {},
});

export const IgnitionRegimeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [selectedRegime, setSelectedRegime] = useState<IgnitionRegime | null>(null);

  const value = useMemo(
    () => ({ selectedRegime, setSelectedRegime }),
    [selectedRegime],
  );

  return (
    <IgnitionRegimeContext.Provider value={value}>
      {children}
    </IgnitionRegimeContext.Provider>
  );
};

export { IgnitionRegimeContext };
